const ACTION_TYPES = {
  SET_USER_DATA: "setUserData",
  SET_PHONENUMBER: "setPhoneNumber",
  SET_PROFILE: "setProfile",
  LOGOUT: "logOut",
  // SET_OTP_STATE: "setOTPState",
};

const userReducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_USER_DATA:
      const { user, token } = action.payload;
      return {
        ...user,
        token,
        phoneNumber: "",
        OTPState: "",
      };

    case ACTION_TYPES.SET_PHONENUMBER:
      return {
        user: {},
        token: "",
        phoneNumber: action.payload,
        OTPState: "",
      };

    case ACTION_TYPES.SET_PROFILE:
      return {
        ...state,
        ...action.payload,
      };

    case ACTION_TYPES.LOGOUT:
      return {
        user: {},
        token: "",
        phoneNumber: "",
        OTPState: "",
      };

    default:
      return state;
  }
};

export default userReducer;
